/* BamBam House: forpöntunarmerki, litahringir á vöruspjöldum (skipta um mynd / rúlla í gegnum liti),
   forpöntunarmerki á mynd í körfu, íþýding á Klaviyo umsagnatexta og frí sending slá í körfu */
(function () {
  var FS_THRESHOLD = 1099000; /* 10.990 kr. (í aurum eins og Shopify notar) */

  var css = ''
    + '.forpontun-card-badge{position:absolute;left:1rem;bottom:1rem;display:flex;flex-wrap:wrap;align-items:center;gap:0.6rem;z-index:4;pointer-events:none;}'
    + '.forpontun-card-badge__label,.forpontun-card-badge__date{font-size:1.1rem;letter-spacing:0.15rem;text-transform:uppercase;line-height:1;padding:0.7rem 1.1rem;}'
    + '.forpontun-card-badge__label{background:#1a1814;color:#fff;}'
    + '.forpontun-card-badge__date{background:rgba(255,255,255,0.92);color:#1a1814;}'
    + '@media screen and (max-width:749px){.forpontun-card-badge{left:0.6rem;bottom:0.6rem;gap:0.4rem;}.forpontun-card-badge__label,.forpontun-card-badge__date{font-size:0.9rem;letter-spacing:0.1rem;padding:0.5rem 0.7rem;}}'
    + '.forpontun-cart-wrap{position:relative !important;display:block !important;}'
    + '.forpontun-cart-badge{position:absolute;left:0;right:0;bottom:0;background:rgba(26,24,20,0.88);color:#fff;font-size:0.9rem;letter-spacing:0.12rem;text-transform:uppercase;text-align:center;padding:0.4rem 0.2rem;line-height:1.3;z-index:2;pointer-events:none;}'
    + '.fs-bar{margin:0 0 1.6rem;padding:1.4rem 1.8rem 1.6rem;background:#ede1ff;border-radius:1.2rem;color:#2b2b2b;text-align:center;}'
    + '.fs-bar[hidden]{display:none !important;}'
    + '.fs-bar .fs-bar__text{margin:0;font-family:"ivypresto-display",serif !important;font-weight:100;font-size:1.9rem;line-height:1.3;letter-spacing:0;color:#2b2b2b;}'
    + '.fs-bar .fs-bar__text strong{font-family:"ivypresto-display",serif !important;font-weight:400;font-style:italic;}'
    + '.fs-bar .fs-bar__track{display:block !important;height:0.6rem;margin-top:1.1rem;border-radius:999px;background:rgba(167,151,187,0.3);overflow:hidden;}'
    + '.fs-bar .fs-bar__fill{display:block !important;height:100%;width:0;min-width:0.6rem;border-radius:999px;background:#a797bb;transition:width 0.45s ease;}'
    + '.fs-bar.is-free .fs-bar__fill{background:#a797bb;}'
    + 'cart-drawer .fs-bar{margin:0 0 1.2rem;}'
    + '@media screen and (max-width:749px){.fs-bar .fs-bar__text{font-size:1.7rem;}}'
    + '.litir-card{display:flex !important;flex-wrap:wrap;align-items:center;gap:0.8rem;margin-top:0.8rem;font-size:1.2rem;letter-spacing:0.05rem;position:relative;z-index:3;}'
    + '.litir-card__dots{display:inline-flex !important;flex-wrap:wrap;gap:0.6rem;}'
    + '.litir-card__dot{display:inline-block !important;width:1.8rem;height:1.8rem;min-width:0;min-height:0;padding:0;margin:0;border:0;border-radius:50%;background:var(--litur);box-shadow:inset 0 0 0 1px rgba(0,0,0,0.18);font-size:0;line-height:0;overflow:hidden;cursor:pointer;transition:transform 0.15s ease;}'
    + '.litir-card__dot:hover{transform:scale(1.15);}'
    + '.litir-card__dot.is-active{box-shadow:inset 0 0 0 1px rgba(0,0,0,0.18),0 0 0 2px #fff,0 0 0 3px #1a1814;}'
    + '.litir-card__dot.is-extra{display:none !important;}'
    + '.litir-card__text{opacity:0.85;}'
    + '.card-information .litir-card,.card__information .litir-card{justify-content:var(--card-text-alignment,left);}'
    + '.card-wrapper .card__media img{transition:opacity 0.2s ease;}';
  var style = document.createElement('style');
  style.setAttribute('data-forpontun-styles', '');
  style.textContent = css;
  document.head.appendChild(style);

  /* ---------- Forpöntunarmerki á vörumynd í körfu ---------- */
  function markCartItems() {
    var items = document.querySelectorAll('.cart-item');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.querySelector('.forpontun-cart-badge')) continue;
      if (item.textContent.indexOf('Forp\u00f6ntun') === -1) continue;
      var img = item.querySelector('.cart-item__media img') || item.querySelector('.cart-item__image') || item.querySelector('img');
      if (!img || !img.parentNode) continue;
      var wrap = img.parentNode;
      wrap.classList.add('forpontun-cart-wrap');
      var badge = document.createElement('span');
      badge.className = 'forpontun-cart-badge';
      badge.textContent = 'Forp\u00f6ntun';
      wrap.appendChild(badge);
    }
  }

  /* ---------- Frí sending slá í körfu ---------- */
  var fsLastKey = null;
  var fsFetching = false;
  var fsCart = null;

  function fsKr(cents) {
    var n = Math.ceil(cents / 100);
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr.';
  }

  function fsMakeBar() {
    var bar = document.createElement('div');
    bar.className = 'fs-bar';
    bar.hidden = true;
    bar.innerHTML = '<p class="fs-bar__text"></p><div class="fs-bar__track"><span class="fs-bar__fill"></span></div>';
    return bar;
  }

  function fsEnsureBars() {
    var head = document.querySelector('cart-drawer .drawer__header');
    if (head && head.parentNode && !head.parentNode.querySelector('.fs-bar')) {
      head.insertAdjacentElement('afterend', fsMakeBar());
    }
    var form = document.querySelector('form#cart');
    if (form && !form.closest('cart-drawer') && form.parentNode && !form.parentNode.querySelector(':scope > .fs-bar')) {
      form.parentNode.insertBefore(fsMakeBar(), form);
    }
  }

  function fsRender() {
    var bars = document.querySelectorAll('.fs-bar');
    if (!bars.length || !fsCart) return;
    var total = fsCart.total_price || 0;
    var empty = !fsCart.item_count;
    var left = FS_THRESHOLD - total;
    var html = left > 0
      ? '\u00de\u00fa ert a\u00f0eins <strong>' + fsKr(left) + '</strong> fr\u00e1 fr\u00edrri sendingu'
      : '<strong>\u00de\u00fa f\u00e6r\u00f0 fr\u00eda sendingu!</strong>';
    var pct = Math.max(0, Math.min(100, Math.round(total * 100 / FS_THRESHOLD)));
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      if (bar.hidden !== empty) bar.hidden = empty;
      var free = left <= 0;
      if (bar.classList.contains('is-free') !== free) bar.classList.toggle('is-free', free);
      var text = bar.querySelector('.fs-bar__text');
      if (text && text.innerHTML !== html) text.innerHTML = html;
      var fill = bar.querySelector('.fs-bar__fill');
      if (fill && fill.style.width !== pct + '%') fill.style.width = pct + '%';
    }
  }

  function fsKey() {
    var sub = document.querySelector('.totals__subtotal-value');
    var count = document.querySelectorAll('.cart-item').length;
    var bubble = document.querySelector('.cart-count-bubble');
    return (sub ? sub.textContent.trim() : '') + '|' + count + '|' + (bubble ? bubble.textContent.trim() : '0');
  }

  function updateFreeShip() {
    fsEnsureBars();
    if (!document.querySelector('.fs-bar')) return;
    var key = fsKey();
    if (key === fsLastKey && fsCart) { fsRender(); return; }
    if (fsFetching) return;
    fsFetching = true;
    fsLastKey = key;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { fsCart = c; fsRender(); })
      .catch(function () {})
      .then(function () { fsFetching = false; });
  }

  /* ---------- Íþýding á Klaviyo umsagnatexta ---------- */
  var KL_SCOPE = '[id*="klaviyo"],[class*="klaviyo"],[class*="kl_reviews"],[class*="kl-reviews"],[id*="kl_reviews"],[data-testid*="review"]';
  var KL_EXACT = {
    'write a review': 'Skrifa ums\u00f6gn',
    'write a review!': 'Skrifa ums\u00f6gn',
    'write review': 'Skrifa ums\u00f6gn',
    'leave a review': 'Skrifa ums\u00f6gn',
    'customer reviews': 'Umsagnir vi\u00f0skiptavina',
    'reviews': 'Umsagnir',
    'review': 'Ums\u00f6gn',
    'questions': 'Spurningar',
    'question': 'Spurning',
    'ask a question': 'Spyrja spurningar',
    'no reviews yet': 'Engar umsagnir enn\u00fe\u00e1',
    'no reviews': 'Engar umsagnir',
    'no questions yet': 'Engar spurningar enn\u00fe\u00e1',
    'be the first to write a review': 'Vertu fyrst til a\u00f0 skrifa ums\u00f6gn',
    'be the first to write a review!': 'Vertu fyrst til a\u00f0 skrifa ums\u00f6gn!',
    'be the first to review this product': 'Vertu fyrst til a\u00f0 gefa \u00feessari v\u00f6ru ums\u00f6gn',
    'be the first to ask a question': 'Vertu fyrst til a\u00f0 spyrja',
    'verified buyer': 'Sta\u00f0festur kaupandi',
    'verified purchase': 'Sta\u00f0fest kaup',
    'verified': 'Sta\u00f0fest',
    'was this helpful?': 'Var \u00feetta gagnlegt?',
    'was this review helpful?': 'Var \u00feessi ums\u00f6gn gagnleg?',
    'helpful': 'Gagnlegt',
    'yes': 'J\u00e1',
    'no': 'Nei',
    'sort by': 'Ra\u00f0a eftir',
    'sort': 'Ra\u00f0a',
    'most recent': 'N\u00fdjast',
    'newest': 'N\u00fdjast',
    'oldest': 'Elst',
    'highest rating': 'H\u00e6sta einkunn',
    'highest rated': 'H\u00e6sta einkunn',
    'lowest rating': 'L\u00e6gsta einkunn',
    'lowest rated': 'L\u00e6gsta einkunn',
    'most helpful': 'Gagnlegast',
    'with photos': 'Me\u00f0 myndum',
    'with media': 'Me\u00f0 myndum',
    'photos': 'Myndir',
    'filter': 'S\u00eda',
    'filters': 'S\u00edur',
    'clear all': 'Hreinsa allt',
    'search reviews': 'Leita \u00ed umsagnum',
    'load more': 'S\u00fdna fleiri',
    'show more': 'S\u00fdna meira',
    'show less': 'S\u00fdna minna',
    'read more': 'Lesa meira',
    'see more reviews': 'Sj\u00e1 fleiri umsagnir',
    'more reviews': 'Fleiri umsagnir',
    'submit': 'Senda',
    'submit review': 'Senda ums\u00f6gn',
    'submit question': 'Senda spurningu',
    'cancel': 'H\u00e6tta vi\u00f0',
    'close': 'Loka',
    'next': '\u00c1fram',
    'back': 'Til baka',
    'skip': 'Sleppa',
    'continue': '\u00c1fram',
    'done': 'B\u00fai\u00f0',
    'name': 'Nafn',
    'your name': 'Nafni\u00f0 \u00feitt',
    'first name': 'Fornafn',
    'last name': 'Eftirnafn',
    'email': 'Netfang',
    'your email': 'Netfangi\u00f0 \u00feitt',
    'email address': 'Netfang',
    'title': 'Fyrirs\u00f6gn',
    'review title': 'Fyrirs\u00f6gn',
    'give your review a title': 'Gef\u00f0u ums\u00f6gninni fyrirs\u00f6gn',
    'your review': '\u00de\u00edn ums\u00f6gn',
    'write your review': 'Skrifa\u00f0u ums\u00f6gnina \u00fe\u00edna',
    'write your review here': 'Skrifa\u00f0u ums\u00f6gnina \u00fe\u00edna h\u00e9r',
    'rating': 'Einkunn',
    'overall rating': 'Heildareinkunn',
    'your rating': '\u00dein einkunn',
    'rate this product': 'Gef\u00f0u v\u00f6runni einkunn',
    'how would you rate this product?': 'Hva\u00f0a einkunn myndir\u00f0u gefa \u00feessari v\u00f6ru?',
    'add photos': 'B\u00e6ta vi\u00f0 myndum',
    'add photo': 'B\u00e6ta vi\u00f0 mynd',
    'add photos or videos': 'B\u00e6ta vi\u00f0 myndum e\u00f0a myndb\u00f6ndum',
    'add media': 'B\u00e6ta vi\u00f0 myndum',
    'upload photos': 'Hla\u00f0a upp myndum',
    'optional': 'Valfrj\u00e1lst',
    'required': 'Nau\u00f0synlegt',
    'thank you!': 'Takk fyrir!',
    'thank you': 'Takk fyrir',
    'thanks for your review!': 'Takk fyrir ums\u00f6gnina!',
    'thank you for your review!': 'Takk fyrir ums\u00f6gnina!',
    'thank you for your review': 'Takk fyrir ums\u00f6gnina',
    'your review has been submitted': 'Ums\u00f6gnin \u00fe\u00edn hefur veri\u00f0 send',
    'your review was submitted': 'Ums\u00f6gnin \u00fe\u00edn hefur veri\u00f0 send',
    'store reviews': 'Umsagnir um verslunina',
    'product reviews': 'Umsagnir um v\u00f6runa',
    'reply from': 'Svar fr\u00e1',
    'store response': 'Svar verslunar',
    'response from the store': 'Svar fr\u00e1 verslun',
    'recommends this product': 'm\u00e6lir me\u00f0 \u00feessari v\u00f6ru',
    'i recommend this product': '\u00c9g m\u00e6li me\u00f0 \u00feessari v\u00f6ru',
    'share': 'Deila',
    'report': 'Tilkynna',
    'all': 'Allt',
    'stars': 'stj\u00f6rnur',
    'star': 'stjarna'
  };
  var KL_RULES = [
    [/^based on\s+(\d+)\s+reviews?$/i, function (m) { return 'Byggt \u00e1 ' + m[1] + (m[1] === '1' ? ' ums\u00f6gn' : ' ums\u00f6gnum'); }],
    [/^\(?(\d+)\)?\s+reviews?$/i, function (m) { return m[1] + (m[1] === '1' ? ' ums\u00f6gn' : ' umsagnir'); }],
    [/^(\d+)\s+questions?$/i, function (m) { return m[1] + (m[1] === '1' ? ' spurning' : ' spurningar'); }],
    [/^(\d+(?:\.\d+)?)\s+out of\s+(\d+)(\s+stars?)?$/i, function (m) { return m[1].replace('.', ',') + ' af ' + m[2]; }],
    [/^(\d+)\s+stars?$/i, function (m) { return m[1] + (m[1] === '1' ? ' stjarna' : ' stj\u00f6rnur'); }],
    [/^(\d+)\s+people found this helpful$/i, function (m) { return m[1] + ' fannst \u00feetta gagnlegt'; }],
    [/^showing\s+(\d+)\s*[-\u2013]\s*(\d+)\s+of\s+(\d+)\s+reviews?$/i, function (m) { return 'S\u00fdni ' + m[1] + ' til ' + m[2] + ' af ' + m[3] + ' ums\u00f6gnum'; }]
  ];

  function klTranslate(str) {
    var trimmed = str.replace(/\s+/g, ' ').trim();
    if (!trimmed) return null;
    var key = trimmed.toLowerCase();
    if (Object.prototype.hasOwnProperty.call(KL_EXACT, key)) return str.replace(trimmed, KL_EXACT[key]);
    for (var i = 0; i < KL_RULES.length; i++) {
      var m = trimmed.match(KL_RULES[i][0]);
      if (m) return str.replace(trimmed, KL_RULES[i][1](m));
    }
    return null;
  }

  function klInScope(el) {
    return !!(el && el.closest && el.closest(KL_SCOPE));
  }

  function translateReviews(root) {
    root = root || document.body;
    if (!root) return;
    var scopes = root.matches && root.matches(KL_SCOPE) ? [root] : [];
    var found = root.querySelectorAll ? root.querySelectorAll(KL_SCOPE) : [];
    for (var s = 0; s < found.length; s++) scopes.push(found[s]);
    if (!scopes.length && root.parentElement && klInScope(root.parentElement)) scopes.push(root);
    for (var k = 0; k < scopes.length; k++) {
      var scope = scopes[k];
      var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null, false);
      var node;
      while ((node = walker.nextNode())) {
        var p = node.parentNode;
        if (!p || p.nodeName === 'SCRIPT' || p.nodeName === 'STYLE') continue;
        var out = klTranslate(node.nodeValue);
        if (out !== null && out !== node.nodeValue) node.nodeValue = out;
      }
      var fields = scope.querySelectorAll('[placeholder],[aria-label],[title],input[type="submit"],input[type="button"]');
      for (var f = 0; f < fields.length; f++) {
        var el = fields[f];
        ['placeholder', 'aria-label', 'title', 'value'].forEach(function (attr) {
          if (attr === 'value' && !(el.type === 'submit' || el.type === 'button')) return;
          var v = el.getAttribute(attr);
          if (!v) return;
          var t = klTranslate(v);
          if (t !== null && t !== v) el.setAttribute(attr, t);
        });
      }
    }
  }

  /* ---------- Litahringir á vöruspjöldum ---------- */
  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  function showImage(card, dot) {
    var img = card.querySelector('.card__media img');
    if (!img || !dot.getAttribute('data-src')) return;
    img.setAttribute('srcset', dot.getAttribute('data-srcset') || '');
    img.setAttribute('src', dot.getAttribute('data-src'));
    img.removeAttribute('loading');
  }

  function commit(card, dots, dot) {
    var i;
    for (i = 0; i < dots.length; i++) dots[i].classList.remove('is-active');
    dot.classList.add('is-active');
    showImage(card, dot);

    var links = card.querySelectorAll('.card__heading a');
    for (i = 0; i < links.length; i++) {
      links[i].setAttribute('href', dot.getAttribute('data-url'));
      links[i].textContent = dot.getAttribute('data-title');
    }

    if (card._litirPrice === undefined) {
      var p = card.querySelector('.price .price-item--regular');
      card._litirPrice = p ? p.textContent : null;
    }
    var newPrice = dot.getAttribute('data-price') || card._litirPrice;
    if (newPrice) {
      var prices = card.querySelectorAll('.price .price-item--regular, .price .price-item--sale');
      for (i = 0; i < prices.length; i++) prices[i].textContent = newPrice;
    }

    var badge = card.querySelector('.forpontun-card-badge');
    if (badge) badge.style.display = dot === dots[card._litirOriginal] ? '' : 'none';
  }

  function initCards() {
    var blocks = document.querySelectorAll('.litir-card:not([data-litir-init])');
    for (var b = 0; b < blocks.length; b++) {
      (function (block) {
        block.setAttribute('data-litir-init', '');
        var card = block.closest('.card-wrapper');
        if (!card) return;
        var dots = Array.prototype.slice.call(block.querySelectorAll('.litir-card__dot'));
        if (dots.length < 2) return;

        var active = 0;
        for (var i = 0; i < dots.length; i++) if (dots[i].classList.contains('is-active')) active = i;
        card._litirOriginal = active;

        var timer = null;
        var step = active;
        var preloaded = false;

        function preload() {
          if (preloaded) return;
          preloaded = true;
          dots.forEach(function (d) {
            if (d.getAttribute('data-src')) { var im = new Image(); im.src = d.getAttribute('data-src'); }
          });
        }

        function currentDot() {
          for (var i = 0; i < dots.length; i++) if (dots[i].classList.contains('is-active')) return dots[i];
          return dots[0];
        }

        function stopCycle() {
          if (timer) { clearInterval(timer); timer = null; }
        }

        dots.forEach(function (dot) {
          dot.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            stopCycle();
            commit(card, dots, dot);
          });
          if (canHover) {
            dot.addEventListener('mouseenter', function () { stopCycle(); preload(); showImage(card, dot); });
            dot.addEventListener('mouseleave', function () { showImage(card, currentDot()); });
          }
        });

        if (canHover) {
          card.addEventListener('mouseenter', function () {
            preload();
            stopCycle();
            step = dots.indexOf(currentDot());
            timer = setInterval(function () {
              step = (step + 1) % dots.length;
              showImage(card, dots[step]);
            }, 900);
          });
          card.addEventListener('mouseleave', function () {
            stopCycle();
            showImage(card, currentDot());
          });
          block.addEventListener('mouseenter', stopCycle);
        }
      })(blocks[b]);
    }
  }

  var timerId = null;
  var busy = false;
  function runAll() {
    busy = true;
    try { markCartItems(); initCards(); translateReviews(document.body); updateFreeShip(); } finally { busy = false; }
  }
  function schedule() {
    if (busy) return;
    clearTimeout(timerId);
    timerId = setTimeout(runAll, 60);
  }

  runAll();
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
})();
